import { render, staticRenderFns } from "./UploadImagesModal.vue?vue&type=template&id=dffcf266&scoped=true&"
import script from "./UploadImagesModal.vue?vue&type=script&lang=js&"
export * from "./UploadImagesModal.vue?vue&type=script&lang=js&"
import style0 from "./UploadImagesModal.vue?vue&type=style&index=0&id=dffcf266&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dffcf266",
  null
  
)

export default component.exports